import { useTranslation } from 'react-i18next';
import { ContactCard } from '~/components/cards/ContactCard';
import type { Quote } from './splitAwardGridTypes';

export function SellerContacts({
  sellerName,
  recipients,
  primaryContactId,
}: Readonly<{
  sellerName: string;
  recipients: Quote['recipients'];
  primaryContactId?: string;
}>) {
  const { t } = useTranslation('general');
  if (recipients.length === 0) return null;
  return (
    <ul
      aria-label={t('contact_card.contacts_for', { name: sellerName })}
      className="mt-1 flex flex-col gap-1 font-normal"
    >
      {recipients.map((recipient) => (
        <li key={recipient.id}>
          <ContactCard
            contact={recipient}
            primary={recipient.id === primaryContactId}
          />
        </li>
      ))}
    </ul>
  );
}
